
var $trsMap2 = {};
var $flightListDep = {};
var $flightListRet = {};
var flightOpen2 = {};
var CONSTANT_NO_PENDING = 0;
$(document).ready(
		function() {

					$trsMap2["departure"] = $("#link-table-multi-prov-dep>tbody>tr");
					$trsMap2["return"] = $("#link-table-multi-prov-ret>tbody>tr");
					
					$flightListDep = $("#link-table-multi-prov-dep [gr=a]");
					$flightListRet = $("#link-table-multi-prov-ret [gr=a]");
					
					$("[name=itinarary_dep], [name=itinarary_ret]").click(function() {						
						
						var providerKey = $(this).attr("providerKey");
						var officeId = $(this).attr("officeId");
						var pendingType = $(this).attr("pendingType");

						if (checkTotalPax2(providerKey) > 0) {
							alert(sprintf(FmtMessage.getMessage('js.search.warning.paxcount'), checkTotalPax2(providerKey)));
							return false;
						}

						if (isContraryProvider()) {
							$('#contraryProviderWarning').show();
						} else {
							$('#contraryProviderWarning').hide();
						}
							
						var flightType = $(this).attr("flightType");
						var $trs = $trsMap2[flightType];
						var index = $(this).attr("index");
												
						if(flightType == "departure"){
							$('#providerKeyDep').val(providerKey);
						}else{
							$('#providerKeyRet').val(providerKey);
						}

						flightOpen2[flightType] = false;

						$trs.not("[index=" + index + "]").hide();
						$trs.filter("[gr=b]").hide();
						$trs.filter("[index=" + index + "][gr=a]").find("a.show").show();
						$trs.filter("[gr=a]").find("a.activeDetail").removeClass("activeDetail").addClass("passiveDetail");
						

						var other = flightType == "departure" ? "return" : "departure";
						var packageId = $(this).attr("packageId");
						var multiProviderEnabled = $(this).attr("multiProviderEnabled");
						var pricingType = $(this).attr("pricingType");
						
						var packageIdOther = Number($('[name=itinarary_'+(other == 'departure' ? 'dep' : 'ret')+']:checked').attr("packageId"));
						var providerKeyOther = $('[name=itinarary_'+(other == 'departure' ? 'dep' : 'ret')+']:checked').attr("providerKey");
						var multiProviderEnabledOther = $('[name=itinarary_'+(other == 'departure' ? 'dep' : 'ret')+']:checked').attr("multiProviderEnabled");
						var pricingTypeOther = $('[name=itinarary_'+(other == 'departure' ? 'dep' : 'ret')+']:checked').attr("pricingType");
						var officeIdOther = $('[name=itinarary_'+(other == 'departure' ? 'dep' : 'ret')+']:checked').attr("officeId");
						var pendingTypeOther = $('[name=itinarary_'+(other == 'departure' ? 'dep' : 'ret')+']:checked').attr("pendingType");

						var isProviderAndPendingTypeMatched = pendingType != CONSTANT_NO_PENDING && pendingType == pendingTypeOther && providerKey == providerKeyOther;
						var isProviderAndPackageAndPricingTypeMatched = (packageId == packageIdOther && providerKey == providerKeyOther && pricingType == pricingTypeOther);

						var samePackage = ((multiProviderEnabled == "true" && multiProviderEnabledOther == "true")
							|| isProviderAndPackageAndPricingTypeMatched)
							&& officeId == officeIdOther
							&& isProviderAndPendingTypeMatched;
						
						resetReturnPrices(other == "departure");
						
						var $selectedTr = $('tr[index='+$(this).attr("index")+']');
						var comb = $selectedTr.data("comb");
						if (comb == null || comb == "") {
							if( flightOpen2[other] == undefined || flightOpen2[other] || !samePackage ){
								filterOtherFlights(providerKey, packageId, (other == "departure"), (multiProviderEnabled == "true"), pricingType, officeId, pendingType);
								flightOpen2[other] = true;
							}
						} else {
							if(flightType == "departure"){
								$("[name=itinarary_ret]").attr('checked', false);								
							}
							filterCombinable($selectedTr, (other == "departure"));
							
							
							$trs.not("[index=" + index + "]").hide();							
						}
						
						showPassengers();
						
						$('html, body').animate({
							scrollTop: $('#mp-show').offset().top
						}, 500);
						
					});


					var $clickedButton = $();
					$(document).on("click",".priceDetailButtonCont",function() {
						
						var $depButton = $('[name=itinarary_dep]:checked');
						var $retButton = $('[name=itinarary_ret]:checked');
						
						var $button = $clickedButton.length > 0 ? $clickedButton : $(this);
						var $flightRow = $button.closest("tr[gr=a]");

						var providerKey = $button.attr("providerKey");
						if (checkAllPriceDetails($depButton, $retButton)) {

							$("#itinarary_departure").val($depButton.val());
							$("#itinarary_return").val($retButton.val());

							var providerKey = $depButton.attr("providerkey");
							var providerId = $depButton.attr("providerid");
							var packageId = Number($depButton.attr("packageId"));
							var flightDeparture = $depButton.attr("flightdeparture");
							var flightArrival = $depButton.attr("flightarrival");
							var rProviderKey = $retButton.attr("providerkey");
							var rProviderId = $depButton.attr("providerid");
							var rPackageId = Number($retButton.attr("packageId"));
							var rFlightDeparture = $retButton.attr("flightdeparture");
							var rFlightArrival = $retButton.attr("flightarrival");

							var faretype = $depButton.attr("faretype");
							var rFaretype = $retButton.attr("faretype");

							if(providerId == rProviderId || setProvidersPassengers(providerId, flightDeparture, flightArrival, faretype) && 
									!setProvidersPassengers(rProviderId, rFlightDeparture, rFlightArrival, rFaretype)){
								setProvidersPassengers(providerId, flightDeparture, flightArrival, faretype);
							}else if(!setProvidersPassengers(providerId, flightDeparture, flightArrival, faretype) && 
								setProvidersPassengers(rProviderId, rFlightDeparture, rFlightArrival, rFaretype)){
									setProvidersPassengers(rProviderId, rFlightDeparture, rFlightArrival, rFaretype);
							}
							var officeId = $depButton.attr("officeId");
							$("#officeId").val(officeId);
							openLoaderBox();
							
							$("#priceDetailForm").submit();
							return true;
						}
					});
					
					$("#searchForm").submit(function() {
						var formValid = $("#searchForm").valid();
						if (formValid)
							openFlightLoaderBox();
						else
							return false;

						return true;
					});

			}
);


/*function showAllItin(departure){
	var flightType;
	if(departure){
		flightType = "departure";
		//$flightListDep.filter("[data-visible=true]").filter("[gr=a]:hidden").show();

	}else{
		flightType = "return";
		//$flightListRet.filter("[data-visible=true]").filter("[gr=a]:hidden").show();

	}
	var $trs = $trsMap2[flightType];
    $trs.filter("[gr=a]:hidden").show();
	flightOpen2[flightType] = true;
	
	if(departure){
		$("[name=itinarary_dep]").attr('checked', false);
	} else {
		$("[name=itinarary_ret]").attr('checked', false);
	}
	
	resetReturnPrices(!departure);
}
*/
function showPassengers() {
//	showCipOption();
//	$("#passengerCount").show();
	
	if($('[name=itinarary_dep]:checked').size() == 1 && $('[name=itinarary_ret]:checked').size() == 1 && !$('[name=itinarary_dep]:checked').is(":hidden") && !$('[name=itinarary_ret]:checked').is(":hidden")){
		
		var packageIdDep = Number($('[name=itinarary_dep]:checked').attr("packageId"));
		var packageIdRet = Number($('[name=itinarary_ret]:checked').attr("packageId"));
		var providerKeyDep = $('[name=itinarary_dep]:checked').attr("providerKey");
		var providerKeyRet = $('[name=itinarary_ret]:checked').attr("providerKey");
		var pricingTypeDep = $('[name=itinarary_dep]:checked').attr("pricingType");
		var pricingTypeRet = $('[name=itinarary_ret]:checked').attr("pricingType");

		var providerIdDep = $('[name=itinarary_dep]:checked').attr("providerid");
		var providerIdRet = $('[name=itinarary_ret]:checked').attr("providerid");
		
		var $selectedTr = $('tr[index='+$("[name=itinarary_dep]:checked").attr("index")+']');
		var comb = $selectedTr.data("comb");
		if((comb != null && comb != "") ||
				(pricingTypeDep == pricingTypeRet && packageIdDep == packageIdRet && (packageIdDep == 0 || providerKeyDep == providerKeyRet))){
			
			var priceDep = parseFloat($('[name=itinarary_dep]:checked').attr("price"));
			var priceRet = parseFloat($('[name=itinarary_ret]:checked').attr("price"));
			var totalPrice = priceDep + priceRet;
			
			if(comb != null && comb != ""){
				totalPrice = priceRet*2;
			}
			
			if(providerIdDep == providerIdRet && providerKeyDep == providerKeyRet && pricingTypeDep == 'FREE_FORM'){
				var serviceFeeDep = parseFloat($('[name=itinarary_dep]:checked').attr("servicefee"));
				var serviceFeeRet = parseFloat($('[name=itinarary_ret]:checked').attr("servicefee"));
				var discount = (serviceFeeDep < serviceFeeRet ? serviceFeeDep : serviceFeeRet);
				
				if(discount > 0){
					$('#sameProviderTotalAmount').html(totalPrice.toFixed(2))
					$('#sameProviderDiscountAmount').html(-1*discount.toFixed(2))
					$('.totalDiscountText').show();
					totalPrice -=   discount;
				}
				else{
					$('.totalDiscountText').hide();
				}
				
				
			}else{
				$('.totalDiscountText').hide();
			}
			$('#totalFareCont').html(totalPrice.toFixed(2));
			$('#continueButton').show();
		}else{
			$('#continueButton').hide();
		}
	}else{
		$('#continueButton').hide();
	}
	
}

function isContraryProvider() {

//	var depKey = $('input[name=itinarary_departure]:checked').attr("providerKey");
//	var retKey = $('input[name=itinarary_return]:checked').attr("providerKey");
//
//	var ret = retKey !== undefined && depKey != retKey;
//	return ret;
	
	return false;
}


function showDetails2(index, departure) {
	var $selectedFlight = {};
	if(departure){
		$selectedFlight = $flightListDep.filter("[index=" + index + "]");
	}else{
		$selectedFlight = $flightListRet.filter("[index=" + index + "]");
	}
	var $selectedDetail = $selectedFlight.next();
	$selectedDetail.toggle();

	var visibleCount = $selectedDetail.filter(":visible").size();
	if (visibleCount == 1) {
		$selectedFlight.find("a.passiveDetail").removeClass("passiveDetail").addClass("activeDetail");
	} else {
		$selectedFlight.filter("[gr=a]").find("a.activeDetail").removeClass("activeDetail").addClass("passiveDetail");
	}
}

var providerRestrictionList = null;

function checkAllPriceDetails($dButton, $rButton){
	
	if (!checkForPriceDeatil2($dButton) || !checkForPriceDeatil2($rButton)) {
		alert(FmtMessage.getMessage('js.search.warning.infant') + "\n\n" + FmtMessage.getMessage('js.search.warning.child'));
		return false;
	} else if (checkTotalPax2($dButton.attr("providerKey")) > 0) {
		alert(sprintf(FmtMessage.getMessage('js.search.warning.paxcount'), checkTotalPax2($dButton.attr("providerKey"))));
		return false;
	} else if (checkTotalPax2($rButton.attr("providerKey")) > 0) {
		alert(sprintf(FmtMessage.getMessage('js.search.warning.paxcount'), checkTotalPax2($rButton.attr("providerKey"))));
		return false;
	} else if (!checkFreeSeat2($dButton, $rButton)) {
		alert(FmtMessage.getMessage('js.error.not.enough.freeseats'));
		return false;
	} else if ($('input[name=direction]:checked').val() == 2 && !checkReturnFlightTime2($dButton, $rButton)) {
		alert(FmtMessage.getMessage('js.search.warning.returnFlightDeparture'));
		return false;
	} else if (!Flight.canDoLastHourRes  && isLastHourFlight($dButton)) {
		alert(FmtMessage.getMessage('js.search.warning.lastHourFlight'));
		return false;
	}
	return true;
}

function checkForPriceDeatil2($button) {

	var adult = $("#numAdult").val();
	var child = $("#numChild").val();
	var infant = $("#numInfant").val();
	var student = $("#numMilitary").val();
	var military = $("#numStudent").val();
	var senior = $("#numSenior").val();
	var young = $("#numYoung").val();

	var totalPax = parseInt(adult) + parseInt(child) + parseInt(infant) + parseInt(student) + parseInt(military) + parseInt(senior)
			+ parseInt(young);

	var cntNonFlyingAloneINF = 0;
	var cntNonFlyingAlonePax = 0;

	var providerId = $button.attr("providerid");
	var flightdeparture = $button.attr("flightdeparture");
	var flightarrival = $button.attr("flightarrival");

	var faretype = $button.attr("faretype");
	
	if(setProvidersPassengers(providerId, flightdeparture, flightarrival, faretype)){
	
		if(providerDefMap[providerId] != null){
			
			if (!providerDefMap[providerId].isChildFlyingAlone)
				cntNonFlyingAlonePax = parseInt(cntNonFlyingAlonePax) + parseInt(child);
			
			if (!providerDefMap[providerId].isInfantFlyingAlone)
				cntNonFlyingAloneINF = parseInt(cntNonFlyingAloneINF) + parseInt(infant);
			
		}

	} else {
		cntNonFlyingAlonePax = parseInt(child);
		cntNonFlyingAloneINF = parseInt(infant);
	};

	if (parseInt(cntNonFlyingAloneINF) > (totalPax - cntNonFlyingAlonePax - cntNonFlyingAloneINF))
		return false;

	if (cntNonFlyingAlonePax > 0 && (totalPax - cntNonFlyingAloneINF - cntNonFlyingAlonePax) < 1)
		return false;

	return true;

}


function checkTotalPax2(providerKey) {
	
	var adult = $("#numAdult").val() !== undefined ? parseInt($("#numAdult").val()) : 0;
	var child = $("#numChild").val() !== undefined ? parseInt($("#numChild").val()) : 0;
	var infant = $("#numInfant").val() !== undefined ? parseInt($("#numInfant").val()) : 0;

	var military = $('#numMilitary').val() !== undefined ? parseInt($("#paxMilitary").val()) : 0;
	var student = $('#numStudent').val() !== undefined ? parseInt($("#paxStudent").val()) : 0;
	var senior = $('#numSenior').val() !== undefined ? parseInt($("#paxSenior").val()) : 0;
	var young = $('#numYoung').val() !== undefined ? parseInt($("#paxYoung").val()) : 0;

	var totalPax = adult + child + infant + military + student + senior + young;

	var paxLimit = 9;
	if (providerKey == 'TravelFusion') {
		paxLimit = 4;
	}else if (providerKey == 'THY' || providerKey == 'THY DOM' || providerKey == 'THY B2C') {
		paxLimit = 7;
	}
	if (totalPax > paxLimit)
		return paxLimit;
	else
		return 0;
}


function checkFreeSeat2($dButton, $rButton) {

	// BTOC-2882 bir ust siniftan ucus onerildigi icin kontrol kapatildi
	return true;
	
	var adult = $("#paxADT").val();
	var child = $("#paxCHD").val();

	var totalPax = parseInt(adult) + parseInt(child);

	var departureFreeSeat = $dButton.attr("freeSeats");
	var returnFreeSeat = $rButton.attr("freeSeats");

	var minFreeSeat = departureFreeSeat;
	if (!isNaN(returnFreeSeat) && parseInt(departureFreeSeat) > parseInt(returnFreeSeat)) {
		minFreeSeat = returnFreeSeat;
	}

	if (parseInt(minFreeSeat) == 0) {
		return true;
	} else if (parseInt(minFreeSeat) < totalPax) {
		return false;
	} else {
		return true;
	}

}

function checkReturnFlightTime2($dButton, $rButton) {
	var departureFlightArrival = parseTRDate($dButton.attr("lastLegArrival"));
	var returnFlightDeparture = parseTRDate($rButton.attr("firstLegDeparture"));

	if (returnFlightDeparture <= departureFlightArrival) {
		return false;
	} else {
		return true;
	}
}


function parseTRDate(dateString) {
	var parts = dateString.split(' ');
	var dateParts = parts[0].split('.');
	var timeParts = parts[1].split(':');

	var date = new Date(dateParts[2], parseInt(dateParts[1], 10) - 1, dateParts[0], timeParts[0], timeParts[1], timeParts[2]);

	return date;
}

function filterOtherFlights(providerKey, packageId, departure, multiProviderEnabled, pricingType, officeId, pendingType) {
	$('#contraryProviderWarning').hide();
	var $trs = $trsMap2[(departure ? "departure" : "return")];
	//$trs.filter("[gr=a]").show();
	//$trs.find("a.show").hide();

	var $inputs = $('[name="itinarary_' + (departure ? 'dep' : 'ret') + '"]');
	var $inputsp = {};
	if (multiProviderEnabled && pendingType == CONSTANT_NO_PENDING){
		$inputsp = $inputs.filter('[multiProviderEnabled=true][officeId=' + officeId + '][pendingType="' + pendingType + '"]');
	}
	else if(multiProviderEnabled)
		$inputsp = $inputs.filter('[multiProviderEnabled=true][officeId=' + officeId + '][providerKey="' + providerKey + '"][pendingType="' + pendingType + '"]');
	else
		$inputsp = $inputs.filter('[providerKey="' + providerKey + '"][packageId="' + packageId + '"][pricingType="' + pricingType + '"][officeId="' + officeId + '"]');
	
	var $inputsn = $inputs.not($inputsp);
	$inputsn.each(function(index) {
		var attrIndex = $(this).attr("index");
		$trs.filter("[index=" + attrIndex + "]").hide();
		
		if(departure){
			//$flightListDep.filter("[index=" + attrIndex + "]").next().andSelf().attr("data-visible","false");
			$flightListDep.filter("[index=" + attrIndex + "]").hide();
		} else {
			//$flightListRet.filter("[index=" + attrIndex + "]").next().andSelf().attr("data-visible","false");
			$flightListRet.filter("[index=" + attrIndex + "]").hide();
		}
	});
	
	if($inputsp.length > 0){
		if(departure){
			$(".result_not_exist_dep").hide();
		}else{
			$(".result_not_exist_ret").hide();
		}
	}else{
		if(departure){
			$(".result_not_exist_dep").show();
		}else{
			$(".result_not_exist_ret").show();
		}
	}
}


//Dönüş uçuşlarının fiyatları paket uçuşlarda gidiş seçildiğinde pakete göre tekrar önyüzde hesaplandığından bu fonksiyona ihtiyaç var
function resetReturnPrices(isSelectedReturn){
	if(isSelectedReturn) return;
	
	$('tr span').find('#priceTextNumber').each(function(index) {
		var retPriceStr = $(this).closest('tr').attr("price");
		var fltPrice = parseFloat(retPriceStr).toFixed(2);
		var priceSplited = fltPrice.toString().split('.');
		var currency = $.cookie("currency");
		$(this).html(priceSplited[0]+"<i>,"+ priceSplited[1]+"<b>"+currency+"</b></i>");
	});	
	
}

function filterCombinable( $selectedTr, isSelectedReturn) {

	var comb = $selectedTr.data("comb");
	if (comb == null || comb == "") {
		return;
	}

	
	var $list;
	if(isSelectedReturn){
		$list = $flightListDep.filter("[data-visible=true]");
	} else {
		$list = $flightListRet.filter("[data-visible=true]");
	
	}
	var selectedPrice = parseFloat($selectedTr.attr("price"));

	$list.each(function(index){
		var itinId = $(this).attr("flightId");
		var index =  $(this).attr("index");
		 $('tr[index='+index+']').filter("[gr=b]").hide();//hide detail
		
		if (comb.indexOf(itinId) < 0) {
			$(this).hide();
		} else {
			$(this).show();
			if(!isSelectedReturn){
				var retPrice = parseFloat($(this).attr("price"));
				var retPriceForCombinedFlights = retPrice*2-selectedPrice; // Paket uçuşlarda müşteriden dönüş uçuşunun iki katı ücret alınır. Ancak listede dönüş fiyatı gösterirken iki katından gidiş fiyatı düşüyoruz
				
				var retIndex = $(this).attr("index");
				
				var fltPrice = parseFloat(retPriceForCombinedFlights).toFixed(2);
				var priceSplited = fltPrice.toString().split('.');
				var currency = $.cookie("currency");
				$(this).find('#priceTextNumber').html(priceSplited[0]+"<i>,"+ priceSplited[1]+"<b>"+currency+"</b></i>");
			}				
		}		
	});
	
	/*
	
	var selectedPrice = Math.round(parseFloat($selectedTr.attr("price")));
	var $inputs = $('[name="itinarary_' + (isSelectedReturn ? 'dep' : 'ret') + '"]');
	$inputs.each(function(index) {
		var attrIndex = $(this).attr("index");
		var $trList = $('tr[index='+attrIndex+']');
		$trList.each(function(index){
			var itinId = $(this).attr("flightId");
			var isDetailTr = $(this).attr("gr") == 'b';
			if(isDetailTr){
				$(this).hide();
			} else {
				if (comb.indexOf(itinId) < 0) {
					$(this).hide();
				} else {
					$(this).show();
					if(!isSelectedReturn){
						var retPrice = Math.round(parseFloat($(this).attr("price")));
						var retPriceForCombinedFlights = retPrice*2-selectedPrice; // Paket uçuşlarda müşteriden dönüş uçuşunun iki katı ücret alınır. Ancak listede dönüş fiyatı gösterirken iki katından gidiş fiyatı düşüyoruz
						
						var retIndex = $(this).attr("index");
						$(this).find('#priceTextNumber').text(retPriceForCombinedFlights)
					}
						
				}
				
			}
			
			
		});
		
	});*/

}
